module.exports = __webpack_public_path__ + "img/winerackdog30.071421f4.jpg";